"use strict";
document.addEventListener('DOMContentLoaded', function() {
  var adpPopup = {
    sPrevious: window.scrollY,
    sDirection: 'down',

    init: function() {
      this.popupInit();
      this.events();
    },

    events: function() {
      var self = this;
      document.addEventListener('click', function(e) {
        if (e.target.closest('.popup-close')) self.closePopup(e.target.closest('.popup-close'));
        if (e.target.closest('.popup-accept')) { self.acceptPopup(e.target.closest('.popup-accept')); self.closePopup(e.target.closest('.popup-accept')); }
        if (e.target.closest('.age-verification__popup-close')) { self.agePopup(e.target.closest('.age-verification__popup-close')); self.closePopup(e.target.closest('.age-verification__popup-close')); }
        if (e.target.closest('.age-verification__button-no')) self.ageDeclined();
        if (e.target.closest('.popup-overlay')) {
          document.querySelectorAll('.popup-open[data-overlay-close="true"]').forEach(function(popup) { self.closePopup(popup); });
        }
      });
      document.addEventListener('keyup', function(e) {
        if (e.key === 'Escape') document.querySelectorAll('.popup-open[data-esc-close="true"]').forEach(function(popup) { self.closePopup(popup); });
        if (e.key === 'F4') document.querySelectorAll('.popup-open[data-f4-close="true"]').forEach(function(popup) { self.closePopup(popup); });
      });
    },

    popupInit: function() {
      var self = this;
      document.addEventListener('scroll', function() {
        var sc = window.scrollY;
        self.sDirection = sc > self.sPrevious ? 'down' : 'up';
        self.sPrevious = sc;
      });
      document.querySelectorAll('.popup').forEach(function(popup) {
        if (popup.dataset.openTrigger === 'manual') {
          var selector = popup.dataset.openManualSelector;
          if (selector) {
            document.querySelectorAll(selector).forEach(function(el) { el.classList.add('popup-trigger'); });
            document.addEventListener('click', function(e) {
              var trigger = e.target.closest(selector);
              if (!trigger) return;
              e.preventDefault();
              popup.classList.remove('popup-already-opened');
              self.openPopup(popup);
              if (trigger.classList.contains('popup')) self.closePopup(trigger);
            });
          }
        }
        if (!self.isAllowPopup(popup) && !popup.classList.contains('age-verification')) return;
        self.openTriggerPopup(popup);
      });
    },

    openTriggerPopup: function(popup) {
      var self = this;
      var trigger = popup.dataset.openTrigger;
      if (trigger === 'none') {
        if (!self.getCookie('popup-age-' + (popup.dataset.id || 0))) self.openPopup(popup);
      }
      if (trigger === 'delay') {
        setTimeout(function() { self.openPopup(popup); }, (popup.dataset.openDelayNumber || 0) * 1000);
      }
      if (trigger === 'exit') {
        var showExit = true;
        document.addEventListener('mousemove', function(e) {
          var scroll = window.pageYOffset || document.documentElement.scrollTop;
          if ((e.pageY - scroll) < 7 && showExit) { self.openPopup(popup); showExit = false; }
        });
      }
      if (trigger === 'scroll') {
        var pst = popup.dataset.openScrollType, psp = popup.dataset.openScrollPosition;
        document.addEventListener('scroll', function() {
          if (pst === 'px' && window.scrollY >= psp) self.openPopup(popup);
          if (pst === '%' && self.getScrollPercent() >= psp) self.openPopup(popup);
        });
      }
      if (trigger === 'accept') {
        if (!self.getCookie('popup-accept-' + (popup.dataset.id || 0))) self.openPopup(popup);
      }
    },

    closeTriggerPopup: function(popup) {
      var self = this;
      var trigger = popup.dataset.closeTrigger;
      if (trigger === 'delay') {
        setTimeout(function() { self.closePopup(popup); }, (popup.dataset.closeDelayNumber || 0) * 1000);
      }
      if (trigger === 'scroll') {
        var pst = popup.dataset.closeScrollType, psp = parseInt(popup.dataset.closeScrollPosition);
        var initPx = parseInt(popup.dataset.initScrollPx), initPct = parseInt(popup.dataset.initScrollPercent);
        document.addEventListener('scroll', function() {
          if (pst === 'px') {
            if (self.sDirection === 'up' && window.scrollY < (initPx - psp)) self.closePopup(popup);
            if (self.sDirection === 'down' && window.scrollY >= (initPx + psp)) self.closePopup(popup);
          }
          if (pst === '%') {
            if (self.sDirection === 'up' && self.getScrollPercent() < (initPct - psp)) self.closePopup(popup);
            if (self.sDirection === 'down' && self.getScrollPercent() >= (initPct + psp)) self.closePopup(popup);
          }
        });
      }
    },

    openPopup: function(popup) {
      if (popup.dataset.bodyScrollDisable === 'true') document.body.classList.add('popup-scroll-hidden');
      var limit = parseInt(this.getCookie('popup-' + popup.dataset.id) || 0) + 1;
      this.setCookie('popup-' + popup.dataset.id, limit, { expires: popup.dataset.limitLifetime });
      if (popup.classList.contains('popup-open') || popup.classList.contains('popup-already-opened')) return;
      popup.classList.add('popup-open');
      popup.dataset.initScrollPx = window.scrollY;
      popup.dataset.initScrollPercent = this.getScrollPercent();
      this.applyAnimation(popup, popup.dataset.openAnimation);
      this.closeTriggerPopup(popup);
    },

    agePopup: function(el) {
      var popup = el.closest('.popup');
      this.setCookie('popup-age-' + popup.dataset.id, 1, { expires: 360 });
    },

    ageDeclined: function() {
      var q = document.querySelector('.age-verification__question');
      var d = document.querySelector('.age-verification__declined');
      if (q) q.classList.remove('show');
      if (d) d.classList.add('show');
    },

    acceptPopup: function(el) {
      var popup = el.closest('.popup');
      this.setCookie('popup-accept-' + popup.dataset.id, 1, { expires: 360 });
    },

    closePopup: function(el) {
      var popup = el.closest ? el.closest('.popup') : el;
      if (!popup) return;
      var animation = popup.dataset.exitAnimation;
      this.applyAnimation(popup, animation, function() {
        popup.classList.add('popup-already-opened');
        popup.classList.remove('popup-open');
        document.body.classList.remove('popup-scroll-hidden');
      });
    },

    isAllowPopup: function(popup) {
      var limitDisplay = parseInt(popup.dataset.limitDisplay || 0);
      var limitCookie = parseInt(this.getCookie('popup-' + popup.dataset.id));
      if (limitDisplay && limitCookie && limitCookie >= limitDisplay) return false;
      return true;
    },

    applyAnimation: function(el, name, callback) {
      var popup = el.closest('.popup') || el;
      var overlayName = callback ? 'popupExitFade' : 'popupOpenFade';
      var overlay = popup.nextElementSibling;
      if (overlay && overlay.classList.contains('popup-overlay')) {
        overlay.classList.add('popup-animated', overlayName);
        overlay.addEventListener('animationend', function handler() {
          overlay.classList.remove('popup-animated', overlayName);
          overlay.removeEventListener('animationend', handler);
        });
      }
      var wrap = popup.querySelector('.popup-wrap');
      if (wrap) {
        wrap.classList.add('popup-animated', name);
        wrap.addEventListener('animationend', function handler() {
          wrap.classList.remove('popup-animated', name);
          wrap.removeEventListener('animationend', handler);
          if (typeof callback === 'function') callback();
        });
      }
    },

    getCookie: function(name) {
      var matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    setCookie: function(name, value, options) {
      options = options || {};
      options.path = options.path || '/';
      options.expires = parseInt(options.expires);
      if (typeof options.expires === 'number' && options.expires) {
        options.expires = new Date(new Date().setDate(new Date().getDate() + options.expires)).toUTCString();
      }
      var cookie = name + '=' + encodeURIComponent(value);
      for (var key in options) { cookie += '; ' + key; if (options[key] !== true) cookie += '=' + options[key]; }
      document.cookie = cookie;
    },

    getScrollPercent: function() {
      var h = document.documentElement, b = document.body;
      return (h.scrollTop || b.scrollTop) / ((h.scrollHeight || b.scrollHeight) - h.clientHeight) * 100;
    }
  };

  adpPopup.init();
  document.addEventListener('shopify:section:load', function() { adpPopup.init(); });
  document.addEventListener('shopify:section:unload', function() { document.body.classList.remove('popup-scroll-hidden'); });
});
